package ru.villawonka.app.presentation.design.extensions

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.*
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material.MaterialTheme
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import ru.villawonka.app.presentation.design.theme.onSurfacePrimary

@Composable
fun ColumnScope.AppDragView() {
    Box(
        modifier = Modifier
            .fillMaxWidth()
            .padding(vertical = 16.dp),
        contentAlignment = Alignment.Center
    ) {
        Box(
            modifier = Modifier
                .size(
                    width = 32.dp,
                    height = 4.dp
                )
                .background(
                    color = MaterialTheme.colors.onSurfacePrimary,
                    shape = RoundedCornerShape(100.dp)
                )
        )
    }
}